// Settlement Reducer
import { Action, Reducer } from 'redux';

// actions
import * as Actions from '../../actions';

import { SettlementState, SettlementUnloadState } from '../../states/SettlementState';
import { Settlement } from '../../../models/Entities/Settlements/Settlement';

type KnownAction =
| Actions.SettlementsResume.SettlementResume_GetAll_Request_Action
| Actions.SettlementsResume.SettlementResume_GetAll_Receive_Action
| Actions.SettlementsResume.SettlementResume_GetAll_Fail_Action

/**
 * Flags de carga de los resúmenes, sobre la liquidación. Los resúmenes en sí
 * los guarda SettlementReducer; acá sólo se marca si se pidieron, si llegaron
 * o si fallaron, para que la pantalla no dependa de que la lista esté vacía.
 */
const patchSettlement = (
    state: SettlementState,
    settlementId: number | undefined,
    patch: Partial<Settlement>
): SettlementState => {
    const current = state.list?.find((settlement: Settlement) => settlement.id === settlementId);
    if (!current) return state;
    return {
        ...state,
        list: [...state.list!.filter((settlement: Settlement) => settlement.id !== settlementId), { ...current, ...patch }]
    };
};

export const SettlementResumeReducer: Reducer<SettlementState> = (
    state: SettlementState | undefined, incomingAction: Action): SettlementState => {

        if (state === undefined) {
            return SettlementUnloadState as SettlementState;
        }

        const action = incomingAction as KnownAction;

        switch (action.type) {
            case 'SETTLEMENTRESUME_GETALL_REQUEST_ACTION':
                return patchSettlement(state, action.settlementId, {
                    isGettingResume: true,
                    isGettingResumeSuccess: undefined,
                    failOnGettingResume: false,
                    ErrorGettingResume: undefined
                });
            case 'SETTLEMENTRESUME_GETALL_RECEIVE_ACTION':
                return patchSettlement(state, action.settlementId, {
                    isGettingResume: false,
                    isGettingResumeSuccess: true,
                    failOnGettingResume: false,
                    ErrorGettingResume: undefined
                });
            case 'SETTLEMENTRESUME_GETALL_FAIL_ACTION':
                return patchSettlement(state, action.settlementId, {
                    isGettingResume: false,
                    isGettingResumeSuccess: false,
                    failOnGettingResume: true,
                    ErrorGettingResume: action.error
                });
            default:
                return state;
        }
    }
